import { API_URL } from "../ConstVariable"

export const GET_CENTER_LIST_URL=`${API_URL}/oi/api/v1/operator-feedback-status-and-centers`

export const CREATE_MANUAL_ORDER_URL=`${API_URL}/oi/api/v1/manualOrder`

export const GET_SCAN_DETAILS=`${API_URL}/oi/api/v1/ScanTypeDetails`

export const GET_COMRAD_SLOTS=`${API_URL}/oi/api/v2/available-slots-in-comrad`

export const GET_OPERATOR_GUIDE_LINES=`${API_URL}/oi/api/operator-guidelines`

export const GET_UNCONCLUDED_CALLS=`${API_URL}/oi/api/v1/unconcluded-calls`;

export const GET_ALL_CALLS=`${API_URL}/oi/api/v3/all-calls`
export const GET_CUSTOMER_LIST=`${API_URL}/oi/api/v2/get-customer-list`

export const GET_DIRECT_CALL_DETAILS=`${API_URL}/oi/api/v2/direct-call-details`

export const GET_DIRECT_CALL_INFO=`${API_URL}/oi/api/v2/get-direct-call-info-data`

export const SAVE_DIRECT_CALL=`${API_URL}/oi/api/v2/direct-call`
